import { User } from '@givelify/api';
import { ImageWithDimensions } from '@givelify/onboarding';
import { AppState } from '..';

export type HeaderUserData = Pick<
    User,
    'avatar' | 'avatarOriginal' | 'fullName'
>;

export interface UserInfoRequest {
    email?: string;
    first_name: string;
    last_name: string;
    title: string;
    // avatar: string;
    role_id: number;
}

export interface ContactInfoRequest {
    first_name: string;
    last_name: string;
    title: string;
    email: string;
    is_contact_info_confirmation: boolean;
}

export const UserPermissions = {
    Basic: 1,
    Financial: 2,
    Admin: 3,
};

export const isLoggedIn = (state: AppState): boolean =>
    !!state.User.accessToken;

export interface UserState {
    accessToken?: string;
    email?: User['email'];
    user: User | null;
    fingerprint?: string;
    hideContinueOnMobileScreen?: boolean;
}

export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_USER = 'SET_USER';
export const SET_USER_AVATAR = 'SET_USER_AVATAR';
export const SET_EMAIL = 'SET_EMAIL';
export const HIDE_CONTINUE_ON_MOBILE_SCREEN = 'HIDE_CONTINUE_ON_MOBILE_SCREEN';
export const SET_FINGERPRINT = 'SET_FINGERPRINT';

export interface SetAccessToken {
    type: typeof SET_ACCESS_TOKEN;
    accessToken: UserState['accessToken'];
}

export interface SetUser {
    type: typeof SET_USER;
    user: UserState['user'];
}

export interface SetUserAvatar {
    type: typeof SET_USER_AVATAR;
    avatar: ImageWithDimensions;
}

export interface SetUserEmail {
    type: typeof SET_EMAIL;
    email?: UserState['email'];
}

export interface SetHideContinueOnMobileScreen {
    type: typeof HIDE_CONTINUE_ON_MOBILE_SCREEN;
}
export interface SetFingerprintAction {
    type: typeof SET_FINGERPRINT;
    fingerprint: UserState['fingerprint'];
}

export type UserActions =
    | SetAccessToken
    | SetUser
    | SetUserEmail
    | SetUserAvatar
    | SetHideContinueOnMobileScreen
    | SetFingerprintAction;
